module.exports = __webpack_public_path__ + "img/Head_fifth.ed6ae945.png";